<template>
    <UModal :title="$t('Terms and conditions')" size="xl">
        <template #body>
                    <div class="p-4 max-h-96 overflow-y-auto">
            <p>
                {{ $t('Here are the terms and conditions...') }}
            </p>
            <!-- Add actual terms and conditions content here -->
        </div>
        </template>
        <template #footer="{ close }">
            <UButton @click="close" color="primary">{{ $t('Close') }}</UButton>
        </template>
    </UModal>
</template>
